'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.policy_type', data.additional_data.coverage_type);
  context.updateProp('application.additional_data.country_of_origin', data.additional_data.country_of_origin);
  context.updateProp('application.additional_data.destination_province', data.additional_data.destination_province);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateCoverageData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/rimi_is/quote.js
// module id = 1734
// module chunks = 0